"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var XLSX = _interopRequireWildcard(require("xlsx"));
var _fileSaver = require("file-saver");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var _transformState = _interopRequireDefault(require("@/utils/transformState.js"));
var dangaoActApi = _interopRequireWildcard(require("@/api/dangaoActApi"));
var orderListApi = _interopRequireWildcard(require("@/api/orderListApi.js"));
var customerOrderApi = _interopRequireWildcard(require("@/api/customerOrderApi.js"));
var _dashboard = require("@/api/dashboard");
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _logDetail = _interopRequireDefault(require("@/views/orderList/order/dangaoOrder/logDetail.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Tinymce: _index.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      companyappAutoList: [],
      companyappAutoListA: [],
      companyappAutoListB: [],
      dateList: [],
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0],
        type: 2
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      storeType: false,
      formStoreSelect: [],
      formStoreSelectedOne: [],
      orderListWx: [],
      dialogVisibleDetals: false,
      popupDetales: {},
      type: null,
      content: '',
      popupDetail: false,
      objRow: {},
      num: null,
      stateMap: [{
        name: '取消预约',
        id: -1
      }, {
        name: '待处理',
        id: 0
      }, {
        name: '已处理',
        id: 1
      }, {
        name: '预约中',
        id: 2
      }, {
        name: '预约成功',
        id: 3
      }],
      request: {
        accompanyPhotoUrl: '',
        accompanyName: '',
        accompanyAge: '',
        accompanyPhone: '',
        accompanySex: '男',
        patientTime: ''
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.handleApiOffsetList(this.listPram);
  },
  methods: {
    throttle: _throttle.default,
    transformState: _transformState.default,
    exportFormJsonToExcel: function exportFormJsonToExcel() {
      // 验证数据存在性
      if (!this.popupDetales.formJson || !Array.isArray(this.popupDetales.formJson)) {
        this.$message.warning('暂无可用数据');
        return;
      }
      try {
        // 数据转换
        var worksheetData = this.popupDetales.formJson.map(function (item) {
          return {
            问题: item.question,
            答案: item.answer
          };
        });

        // 创建工作簿
        var worksheet = XLSX.utils.json_to_sheet(worksheetData);
        var workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, this.popupDetales.serviceName);

        // 生成Excel文件
        var excelBuffer = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });

        // 文件下载
        var dataBlob = new Blob([excelBuffer], {
          type: 'application/octet-stream'
        });
        (0, _fileSaver.saveAs)(dataBlob, "".concat(this.popupDetales.serviceName, "_").concat(new Date().getTime(), ".xlsx"));
      } catch (error) {
        this.$message.error('导出失败：' + error.message);
        console.error('Excel导出错误:', error);
      }
    },
    // 核销订单列表
    handleApiOffsetList: function () {
      var _handleApiOffsetList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(listPram) {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              console.log(this.listPram);
              _context.n = 1;
              return (0, _dashboard.serviceLogList)(_objectSpread({}, this.listPram));
            case 1:
              res = _context.v;
              this.listData.list = res.list;
              this.listData.total = res.total;
              this.listLoading = false;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function handleApiOffsetList(_x) {
        return _handleApiOffsetList.apply(this, arguments);
      }
      return handleApiOffsetList;
    }(),
    // 获取到商家列表 当缓存里没有时调
    handleStoreListSelect: function () {
      var _handleStoreListSelect = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return customerOrderApi.companyAutoListByTypetApi({
                type: 4
              });
            case 1:
              res = _context2.v;
              this.storeType = true;
              this.formStoreSelect = res;
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleStoreListSelect() {
        return _handleStoreListSelect.apply(this, arguments);
      }
      return handleStoreListSelect;
    }(),
    //获取到店铺列表
    handleSelectedList: function () {
      var _handleSelectedList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return customerOrderApi.companyAutoListByTypestApi({
                offlineSupplierId: this.listPram.offlineSupplierId
              });
            case 1:
              res = _context3.v;
              this.formStoreSelectedOne = res;
              this.handerSearch();
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function handleSelectedList() {
        return _handleSelectedList.apply(this, arguments);
      }
      return handleSelectedList;
    }(),
    // 获取小程序的列表
    handleAppWxOrderList: function () {
      var _handleAppWxOrderList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return customerOrderApi.companyappAutoListApi();
            case 1:
              res = _context4.v;
              this.orderListWx = res;
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleAppWxOrderList() {
        return _handleAppWxOrderList.apply(this, arguments);
      }
      return handleAppWxOrderList;
    }(),
    handleReset: function handleReset() {
      this.listPram = {};
      this.dateList = [];
    },
    // 跳转到优惠券导入页
    goUserCouponImport: function goUserCouponImport() {
      this.$router.push({
        path: '/maintain/import/userCouponImport'
      });
    },
    // 搜索
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handleApiOffsetList(this.listPram);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handleApiOffsetList(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handleApiOffsetList(this.listPram);
    },
    // 查看订单详情
    openOrderDetail: function () {
      var _openOrderDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(row) {
        var res, _t;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              this.type = row.serviceCode;
              _context5.n = 1;
              return (0, _dashboard.serviceLogInfo)({
                id: row.id
              });
            case 1:
              res = _context5.v;
              this.popupDetales = res;
              this.popupDetales = _objectSpread(_objectSpread({}, res), {}, {
                serviceJson: this.safeParse(res.serviceJson),
                patientJson: this.safeParse(res.patientJson),
                disposeJson: this.safeParse(res.disposeJson),
                cancelJson: this.safeParse(res.cancelJson),
                accompanyJson: this.safeParse(res.accompanyJson),
                formJson: this.safeParse(res.formJson)
              });
              console.log(this.popupDetales.formJson, 'formJson');
              this.dialogVisibleDetals = true;
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t = _context5.v;
              console.log(_t);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function openOrderDetail(_x2) {
        return _openOrderDetail.apply(this, arguments);
      }
      return openOrderDetail;
    }(),
    safeParse: function safeParse(jsonStr) {
      try {
        return jsonStr && typeof jsonStr === 'string' ? JSON.parse(jsonStr) : false;
      } catch (e) {
        console.warn('JSON 解析失败:', jsonStr, e);
        return false;
      }
    },
    // 取消
    canleClose: function () {
      var _canleClose = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(row, num) {
        var res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              this.objRow = row;
              this.num = num;
              if (!(num == 3)) {
                _context6.n = 2;
                break;
              }
              _context6.n = 1;
              return (0, _dashboard.serviceCancelGetDisposeInfo)(row.id);
            case 1:
              res = _context6.v;
              this.request = _objectSpread({}, res);
              if (this.$refs.tinymceEditor && this.$refs.tinymceEditor.setContent) {
                this.$refs.tinymceEditor.setContent(res.content);
              }
              this.content = res.content;
              _context6.n = 3;
              break;
            case 2:
              this.content = '';
              // ✅ 强制更新 Tinymce 内容
              if (this.$refs.tinymceEditor && this.$refs.tinymceEditor.setContent) {
                this.$refs.tinymceEditor.setContent('');
              }
            case 3:
              this.popupDetail = true;
            case 4:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function canleClose(_x3, _x4) {
        return _canleClose.apply(this, arguments);
      }
      return canleClose;
    }(),
    // 提交
    handleSubmitText: function () {
      var _handleSubmitText = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _t2;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              if (!(this.num == 1)) {
                _context7.n = 2;
                break;
              }
              _context7.n = 1;
              return (0, _dashboard.serviceCancelDispose)({
                content: this.content,
                id: this.objRow.id,
                serviceCode: this.objRow.serviceCode
              });
            case 1:
              _context7.n = 5;
              break;
            case 2:
              if (!(this.num == 2)) {
                _context7.n = 4;
                break;
              }
              _context7.n = 3;
              return (0, _dashboard.serviceCancelUploadDisposee)(_objectSpread(_objectSpread({}, this.request), {}, {
                content: this.content,
                serviceCode: this.objRow.serviceCode,
                id: this.objRow.id
              }));
            case 3:
              _context7.n = 5;
              break;
            case 4:
              if (!(this.num == 3)) {
                _context7.n = 5;
                break;
              }
              _context7.n = 5;
              return (0, _dashboard.serviceCancelUpdateDispose)(_objectSpread(_objectSpread({}, this.request), {}, {
                content: this.content,
                serviceCode: this.objRow.serviceCode,
                id: this.objRow.id
              }));
            case 5:
              this.$message.success('提交成功');
              this.handleApiOffsetList(this.listPram);
              this.popupDetail = false;
              _context7.n = 7;
              break;
            case 6:
              _context7.p = 6;
              _t2 = _context7.v;
              this.$message.error(_t2);
            case 7:
              return _context7.a(2);
          }
        }, _callee7, this, [[0, 6]]);
      }));
      function handleSubmitText() {
        return _handleSubmitText.apply(this, arguments);
      }
      return handleSubmitText;
    }(),
    handleExprot: function handleExprot(url) {
      window.open(url);
    },
    //上传图片
    handleUploadFormNew: function () {
      var _handleUploadFormNew = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(file) {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return this.uploadItemNew.call(this, file);
            case 1:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function handleUploadFormNew(_x5) {
        return _handleUploadFormNew.apply(this, arguments);
      }
      return handleUploadFormNew;
    }(),
    uploadItemNew: function uploadItemNew(param) {
      var _this = this;
      var formData = new FormData();
      var data = {
        model: 'supplier',
        pid: 10
      };
      formData.append('multipart', param.file);
      var loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      return (0, _dashboard.fileImageApi)(formData, data).then(function (res) {
        console.log(res, 'RES');
        _this.request.accompanyPhotoUrl = res.url;
        loading.close();
        _this.$message.success('上传成功');
        console.log();
      }).catch(function (res) {
        loading.close();
      });
    }
  }
};